import { useCallback, useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import * as partnerService from '../../../data-layer/partner/service';
import { downloadFile } from '../../../utils/downloadFile';
import { useTranslation } from '../../../utils/useTranslation';
import { IconDownload } from '../../icon/IconDownload';
import { Button } from '../../input/Button';
import { Spin } from '../../layout/Spin/Spin';
import { Image } from '../../media/Image';
import { Typography } from '../../typography/Typography';
import { ErrorMessage } from '../PartnerRegistrationForm/components/ErrorMessage';
import { ActionButton, ActionButtonWrapper } from '../PartnerRegistrationForm/styles';
import checkedImage from './resources/checked.png';
import { Container, ImageContainer } from './styles';
import { DownloadOfferProps } from './types';

export const PartnerDownloadOffer = ({
    onSubmit,
    onDownloadError,
    isLoading,
    errorMessage,
}: DownloadOfferProps) => {
    const t = useTranslation();
    const [isDownloading, setIsDownloading] = useState(false);

    const onDownloadOfferClick = useCallback(async () => {
        if (isDownloading) {
            return;
        }
        setIsDownloading(true);
        try {
            const blob = await partnerService.downloadOfferPdf();
            downloadFile(blob, 'Офферта');
        } catch (_error) {
            onDownloadError('Не удалось скачать оферту. Попробуйте ещё раз');
        } finally {
            setIsDownloading(false);
        }
    }, [onDownloadError, isDownloading]);

    return (
        <Container>
            <ImageContainer>
                <Image
                    src={checkedImage}
                    alt="Готово"
                    width="100%"
                    height="100%"
                    objectFit="contain"
                />
            </ImageContainer>

            <Typography variant="title2" weight="medium" textAlign="center" mb={1}>
                {t('Готово — осталось отправить')}
            </Typography>

            <Typography variant="body" textAlign="center" mb={2.5}>
                {t('Если нужно, скачайте оферту')}
            </Typography>

            <ActionButton
                color="secondary"
                size="l"
                width="168px"
                onClick={onDownloadOfferClick}
                mb={3}
                spacing={1}
            >
                {isDownloading ? (
                    <Spin size={20} />
                ) : (
                    <>
                        <IconDownload size={20} />
                        <Typography variant="caption" weight="bold">
                            {t('Скачать оферту')}
                        </Typography>
                    </>
                )}
            </ActionButton>

            <ActionButtonWrapper>
                <Button width="100%" color="primary" size="l" onClick={onSubmit}>
                    {isLoading ? <Spin color="var(--color-invert)" size={20} /> : t('Отправить')}
                </Button>
                <Typography variant="caption" color="secondary" textAlign="center" mt={1} px={0.5}>
                    {t(
                        'Нажимая на кнопку «Отправить», вы направляете оферту на заключение договора в отношении Пакета Дистрибуции «Яндекс. Ритм»',
                    )}
                </Typography>
                <ErrorMessage message={errorMessage} />
            </ActionButtonWrapper>
        </Container>
    );
};
